<template>
  <div class="upcoming-events">
    <h3 class="upcoming-events__title">Kommende Flohmärkte</h3>
    <div v-if="loading" class="upcoming-events__loading">Lade kommende Flohmärkte...</div>
    <div class="upcoming-events__list" v-else-if="getUpcomingEvents && getUpcomingEvents.length > 0">
      <div 
        class="upcoming-events__item" 
        v-for="(event, index) in getUpcomingEvents" 
        :key="event.id"
        @click="navigateToEvent(event)"
        :style="getItemStyle(event, index)"
      >
        <div class="upcoming-events__date">
          <span class="upcoming-events__day">{{ formatDay(event.startdate) }}</span>
          <span class="upcoming-events__month">{{ formatMonth(event.startdate) }}</span>
        </div>
        <div class="upcoming-events__info">
          <h4 class="upcoming-events__event-title">{{ event.title }}</h4>
          <p class="upcoming-events__location">{{ event.eventlocation.title }}</p>
          <p class="upcoming-events__time">{{ formatTime(event.starttime) }} - {{ formatTime(event.endtime) }}</p>
        </div>
      </div>
    </div>
    <p v-else class="upcoming-events__no-events">Keine kommenden Flohmärkte verfügbar</p>
  </div>
  </template>

  <script>
  import { mapGetters, mapActions } from 'vuex'
  import { formatDate, formatTime, formatShortDate } from "@/helpers/filters";
  
  export default {
    name: 'AppUpcomingEvents',
    data() {
      return {
        loading: true
      }
    },
    computed: {
      ...mapGetters('upcomingEvents', ['getUpcomingEvents'])
    },
    async mounted() {
      await this.fetchUpcomingEvents()
      this.loading = false
    },
    methods: {
      ...mapActions('upcomingEvents', ['fetchUpcomingEvents']),
      navigateToEvent(event) {
        this.$router.push({
          name: 'Events',
          params: { id: event.eventlocation.id },
          query: { eventId: event.id }
        })
      },
      getItemStyle(event, index) {
        const color = event && event.eventlocation && event.eventlocation.color;
        if (index < 3 && color) {
          return { borderLeft: `4px solid ${color}` }
        }
        return {}
      },
      formatDay(date) {
        return formatShortDate(date, { day: 'numeric' })
      },
      formatMonth(date) {
        return formatShortDate(date, { month: 'short' })
      },
      formatTime(time) {
        return formatTime(time)
      }
    }
  }
  </script>
  

